import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { TYPE_INPUT, TYPE_CHECKBOX, TYPE_DATETIME, TYPE_DROPDOWN, DropdownIfc } from './utility-list';
import Datetime from 'react-datetime';
import { DateTime } from 'luxon';
import { ListColumnFilter } from './list-entities/ListColumnFilter';

export interface FiltersConfigList {
  type: string;
  name: string;
  operator: string;
  placeholder?: string;
  grow?: number;
  contextForDropdown?: DropdownIfc[];
  checkBoxValue?: string;
  labelForCheckBox?: string;
  customFilter?: any;
}

interface FilterWrapperProps {
  filtersConfigList: ListColumnFilter[];
  onChangeAnyFilter: (
    filters: { [index: string]: string },
    filterHash: string | boolean,
    cleanFilters?: boolean
  ) => void;
  filtersHash: string | boolean;
  initFilters: any;
}

let filters: { [index: string]: string } = {};

const FilterWrapperForList = (props: FilterWrapperProps) => {
  const [initFiltersHasBeenCharged, setInitFiltersHasBeenCharged] = useState<boolean>(false);

  const onChangeFilter = (e: any, checkBoxValue?: any) => {
    if (e.target.type === 'checkbox')
      filters[e.target.name] = filters[e.target.name] === checkBoxValue ? '' : checkBoxValue;
    else filters[e.target.name] = e.target.value;

    // setFiltersHash(!filtersHash);
    props.onChangeAnyFilter(filters, !props.filtersHash);
  };

  const onChangeSelectFilter = (e: any) => {
    filters[e.target.name] = e.target.value;
    // setFiltersHash(e.target.value);
    props.onChangeAnyFilter(filters, e.target.value);
  };

  const onClearFilters = (e: any) => {
    for (let k in filters) {
      filters[k] = '';
    }
    // setFiltersHash('');
    props.onChangeAnyFilter(filters, '', true);
  };

  const handleDateChangeWrapper = (e: any, name: string) => {
    const d = DateTime.fromJSDate(e._d);
    filters[name] = d.toUTC().toISO();
    props.onChangeAnyFilter(filters, d.toUTC().toISO());
  };

  useEffect(() => {
    if (!initFiltersHasBeenCharged && props.filtersConfigList.length > 0) {
      filters = props.initFilters;
      setInitFiltersHasBeenCharged(true);
      props.onChangeAnyFilter(filters, '');
    }
  }, [props.filtersConfigList, props.initFilters]);

  useEffect(() => {}, [props.initFilters]);

  return (
    <div>
      <div className="">
        <Col>
          <Row>
            {props.filtersConfigList
              ? props.filtersConfigList.map((filterConfig, index) => {
                  return (
                    <React.Fragment key={index}>
                      {filterConfig.type === TYPE_INPUT ? (
                        <Col xs={filterConfig.grow}>
                          <Input
                            type="text"
                            className="mb-2"
                            placeholder={filterConfig.placeholder}
                            name={filterConfig.name}
                            value={filters[filterConfig.name] ? filters[filterConfig.name] : ''}
                            onChange={onChangeFilter}
                          />
                        </Col>
                      ) : null}

                      {filterConfig.type === TYPE_DROPDOWN ? (
                        <Col xs={filterConfig.grow}>
                          <select
                            placeholder={filterConfig.placeholder}
                            className="custom-select"
                            name={filterConfig.name}
                            onChange={onChangeSelectFilter}
                            value={filters[filterConfig.name]}
                          >
                            <option value={''} key={'default'}>
                              {' '}
                            </option>
                            {filterConfig &&
                            filterConfig.contextForDropdown &&
                            Array.isArray(filterConfig.contextForDropdown)
                              ? filterConfig.contextForDropdown.map((contextItem, index) => {
                                  return (
                                    <option value={contextItem.value} key={index}>
                                      {contextItem.label}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                        </Col>
                      ) : null}

                      {filterConfig.type === TYPE_CHECKBOX ? (
                        <Col xs={filterConfig.grow}>
                          <div className="checkbox c-checkbox mt-2">
                            <label className="mb-1">
                              <Input
                                type="checkbox"
                                name={filterConfig.name}
                                // value={filterConfig.checkBoxValue}
                                value={filters[filterConfig.name]}
                                checked={filters[filterConfig.name] === filterConfig.checkBoxValue}
                                onChange={(e: any) => onChangeFilter(e, filterConfig.checkBoxValue)}
                              />
                              <span className="fa fa-check"></span> {filterConfig.labelForCheckbox}
                            </label>
                          </div>
                        </Col>
                      ) : null}

                      {filterConfig.type === TYPE_DATETIME ? (
                        <Col xs={filterConfig.grow}>
                          <div className="">
                            <Datetime
                              dateFormat="DD/MM/YYYY"
                              onChange={(e) => handleDateChangeWrapper(e, filterConfig.name)}
                              value={filters[filterConfig.name] ? filters[filterConfig.name] : ''}
                              inputProps={{
                                className: 'form-control',
                                placeholder: filterConfig.placeholder,
                              }}
                              renderInput={(props) => {
                                return (
                                  <input {...props} value={filters[filterConfig.name] ? props.value : ''} />
                                );
                              }}
                            />
                            <i className=" into-input fa fa-calendar"></i>
                          </div>
                        </Col>
                      ) : null}

                      {/* {filterConfig.customFilter ? <div>{filterConfig.customFilter}</div> : null} */}
                    </React.Fragment>
                  );
                })
              : null}
            <div className="col-4" style={{ marginTop: '0px' }}>
              <Button
                style={{ marginTop: '0px' }}
                color="info"
                onClick={onClearFilters}
                className="btn-labeled btn-sm float-right"
              >
                <span className="btn-label">
                  <i className="fa fa-recycle"></i>
                </span>{' '}
                Limpiar filtros
              </Button>
            </div>
          </Row>
        </Col>
      </div>
    </div>
  );
};

export default FilterWrapperForList;
